import React, { useRef } from "react";
import { sortableContainer, sortableElement } from "react-sortable-hoc";

const SortableElement = sortableElement((props) => {
  return <>{props.children}</>;
});

const SortableContainer = sortableContainer(({ children }) => {
  return <ul className="ui-sortable-list">{children}</ul>;
});

const SortableRows = (props) => {
  const optionsRef = useRef(null);
  const handleOptionsSort = ({ oldIndex, newIndex }) => {
    if (props.onSort) {
      props.onSort(oldIndex, newIndex);
    }
  };

  return (
    <>
      <div className="sortables" ref={optionsRef}>
        <SortableContainer
          lockOffset={["0%", "50%"]}
          onSortEnd={handleOptionsSort}
          lockAxis="y"
          helperContainer={() => {
            return optionsRef.current;
          }}
          lockToContainerEdges
          disableAutoscroll
          useDragHandle
        >
          {React.Children.map(props.children, (c, index) => {
            return (
              <SortableElement key={props.key} index={index}>
                {c}
              </SortableElement>
            );
          })}
        </SortableContainer>
      </div>
    </>
  );
};
export default SortableRows;
